import Hero from "@/components/home/Hero";
import { Constat, ExpertiseRows, Methode, Pourquoi } from "@/components/home/Sections";
import { Marquee, CtaBlock, SectionHead, TextLink } from "@/components/site/Ui";
import ProjectRows from "@/components/site/Projects";
import Plans from "@/components/site/Plans";
import BrandGrid from "@/components/site/BrandGrid";
import { Btn } from "@/components/site/Ui";
import { useSeo } from "@/lib/seo";

export default function Home() {
  useSeo({
    title: "Création de site internet & référencement local à Toulouse | SANAA DESIGN STUDIO",
    description: "Web designer indépendante à Toulouse : sites sur mesure pour commerces, restaurants et instituts, réservation en ligne et visibilité Google.",
    path: "/",
  });
  return (
    <>
      <Hero />
      <Marquee />
      <section className="wrap py-20 md:py-28" data-testid="section-portfolio">
        <div className="mb-6 flex flex-col justify-between gap-6 md:flex-row md:items-end">
          <SectionHead label="Sélection de projets" lines={["Des sites qui travaillent", "pour leurs propriétaires."]} />
          <TextLink to="/realisations" testid="portfolio-all">Toutes les réalisations</TextLink>
        </div>
        <ProjectRows />
      </section>
      <section className="wrap py-20 md:py-28" data-testid="section-identite">
        <SectionHead label="Au-delà du site" lines={["Une marque se voit", "avant de se lire."]} className="mb-12">
          Logo, packaging, visuels produits : je construis l'univers complet de votre marque, pour que votre site, vos réseaux et vos produits parlent d'une seule voix.
        </SectionHead>
        <BrandGrid testid="home-brand-grid" />
        <p className="mt-6 font-mono text-[13px] text-mute">Maison Sanaa — concept d'univers produit</p>
        <div className="mt-10"><Btn to="/contact" track="cta_brand" testid="brand-cta">Parler de ma marque</Btn></div>
      </section>
      <Constat />
      <section className="wrap py-20 md:py-28" data-testid="section-expertises">
        <SectionHead label="Ce que je fais" lines={["Tout ce qu'il faut pour", "être trouvé et choisi."]} className="mb-12" />
        <ExpertiseRows />
      </section>
      <section className="on-dark bg-ink py-20 text-ivory md:py-32" data-testid="section-formules">
        <div className="wrap">
          <SectionHead label="Formules" lines={["Des tarifs clairs,", "dès le départ."]} className="mb-14" />
          <Plans />
        </div>
      </section>
      <Methode />
      <Pourquoi />
      <CtaBlock />
    </>
  );
}
